/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */

import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import { get } from '../lib/props';
import './product-filter-count';

export const PLUGIN_NAME = 'productFilterActiveButton';

export const DEFAULTS = {
  clearAllText: get('rcProps.filter.clearAllText', 'Clear All'),
  filteredByText: get('rcProps.filter.filteredByText', 'Filtered By'),
  mountEl: null,
  layoutType: 'default'
};

const isSmartFiltersPage = () => $('#smart-filters').length > 0;

const createCloseIcon = () => {
  const iconClasses = isSmartFiltersPage() ? 'u-margin-l--xs' : 'icon--xs u-margin-l--sm';
  return `<span class="icon icon--x ${iconClasses}">
            <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"
                role="presentation">
                <path
                    d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28
                        4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8
                        9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">
                </path>
            </svg>
        </span>`;
}

const createFilterButton = (text, isSmartFilter, layoutType) => {
  if (isSmartFiltersPage()) {
    return isSmartFilter
      ?`<li class="horizontal-scroll__item horizontal-scroll__item--basis-none">
            <div class="pill-button pill-button--white-blk-stroke">
                <span class="icon icon--smart-filters icon icon--xs u-padding-l--none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M6.55625 14.3982C5.9875 10.2414 5.76 10.0051 1.6125 9.445C1.2625 9.40124 1 9.1037 1 
                                8.7449C1 8.39485 1.2625 8.0973 1.6125 8.05354C5.76875 7.48471 5.99625 7.25718 6.565 
                                3.10031C6.6175 2.71525 6.97625 2.45272 7.3525 2.50522C7.65875 2.54898 7.90375 2.79402 
                                7.9475 3.10031C8.5075 7.25718 8.74375 7.48471 12.8913 8.05354C13.2413 8.0973 13.5037 
                                8.39485 13.5037 8.7449C13.5037 9.09495 13.2413 9.39249 12.8913 9.445C8.735 10.0051 
                                8.5075 10.2414 7.9475 14.3982C7.895 14.7833 7.53625 15.0458 7.16 14.9933C6.85375 
                                14.9496 6.60875 14.7045 6.565 14.3982H6.55625ZM12.1475 5.89197C11.9113 4.18547 11.8238 
                                4.08921 10.1175 3.85292C9.9775 3.83542 9.86375 3.7129 9.86375 3.57288C9.86375 3.42411 
                                9.96875 3.30159 10.1175 3.28409C11.8238 3.05655 11.92 2.96029 12.1475 1.25379C12.165 
                                1.10502 12.2875 1 12.4275 1C12.5675 1 12.69 1.10502 12.7163 1.24504C12.9438 2.95154 
                                13.04 3.0478 14.7463 3.27534C14.895 3.29284 15 3.41536 15 3.56413C15 3.7129 14.895 
                                3.82667 14.7463 3.84417C13.04 4.0717 12.9438 4.16797 12.7163 5.88322C12.69 6.02324 
                                12.5763 6.12826 12.4275 6.13701C12.2788 6.13701 12.165 6.03199 12.1388 5.88322L12.1475 
                                5.89197Z" fill="#6E6E6E">
                                
                        </path>
                    </svg>
                </span>
                <span class="u-margin-l--md">${text}</span>
                ${createCloseIcon()}
            </div>
        </li>`
      : `<li class="horizontal-scroll__item horizontal-scroll__item--basis-none">
            <div class="pill-button pill-button--light-grey">
                <span>${text}</span>
                ${createCloseIcon()}
            </div>
        </li>`;
  } else {
    const cssClasses = layoutType === 'inline' ? 'horizontal-scroll__item horizontal-scroll__item--basis-none' : 'u-inline-block u-padding-t--md u-padding-r--md' ;
    return `<li class="${cssClasses}">
                <button class="pill-button pill-button--light-grey">
                    ${text}
                    ${createCloseIcon()}
                </button>
            </li>`;
  }
}

const containerButtonsDefaultLayout = (clearAllText, filteredByText) => {
  return `<div class="u-padding-b--lg u-margin-b--xxl u-border-b u-border--xs u-border--color-lighter">
    <div class="u-flex u-flex--space-between"><h2 class="h3-secondary u-capitalize u-margin-tb--none">${filteredByText}:</h2> <button class="link u-lowercase js-search-multi-filter-clear-all">${clearAllText}</button></div>
    <ul class="u-margin-l--none u-padding-t--xl"></ul>
  </div> `;
}

const containerButtonsPageLayout = (clearAllText, filteredByText) => {
  return `<div class="u-padding-b--lg">
    <div class="u-flex u-flex--space-between"><h2 class="u-text--lg u-weight--normal u-capitalize u-margin-t--md u-margin-b--none">${filteredByText}:</h2></div>
    <ul class="u-margin-l--none u-padding-b--md"><li class="u-inline-block u-padding-t--md u-padding-r--md"><button class="pill-button pill-button--black js-search-multi-filter-clear-all">${clearAllText}</button></li></ul>`;
}

const containerButtonsInlineLayout = (clearAllText, filteredByText) => {
  return `<div class="u-padding-b--lg u-flex">
    <div style="white-space: nowrap;"><h2 class="u-text--md u-weight--normal u-capitalize u-margin-t--md u-margin-b--none">${filteredByText}:</h2></div>
    <div class="horizontal-scroll" style="width: initial;">
      <ul class="horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--none"></ul>
    </div>
    <button class="pill-button pill-button--black js-search-multi-filter-clear-all" style="white-space: nowrap; margin-left: 8px">${clearAllText}</button>
  </div>`;
}

const createContainerButtons = (clearAllText, filteredByText, layoutType) => {
  if (isSmartFiltersPage()) {
    return `<div class="u-flex u-flex--v-ctr u-padding-tb--lg">
                 <div class="filters__container--sub u-flex u-flex--v-ctr">
                    <span class="u-font-primary u-text-transform-none u-text--lg u-white-space--nowrap">
                        ${filteredByText}
                    </span>
                    <div class="horizontal-scroll u-margin-l--lg u-flex u-flex--wrap u-margin-t--xs u-margin-b--none u-padding-b--none" style="gap: 8px;">
                        <ul class="horizontal-scroll__item-wrap u-margin-b--none"></ul>
                    </div>
                    <button class="pill-button pill-button--black u-white-space--nowrap u-margin-l--lg js-clear-filters-button">${clearAllText}</button>
                 </div>
            </div>`;
  } else {
    switch (layoutType) {
      case 'page':
        return containerButtonsPageLayout(clearAllText, filteredByText);
      case 'inline':
        return containerButtonsInlineLayout(clearAllText, filteredByText);
      default:
        return containerButtonsDefaultLayout(clearAllText, filteredByText);
    }
  }
}

const addButtonsContainer = ($filtersContainer, $checkboxes, { clearAllText, filteredByText, layoutType }) => {
  const $buttonContainer = $(createContainerButtons(clearAllText, filteredByText, layoutType));
  const $clearAllButton = $buttonContainer.find('button');

  $filtersContainer.prepend($buttonContainer);

  $clearAllButton.on('click', () => {
    $checkboxes.each((index, checkbox) => {
      if (checkbox.checked) {
        $(checkbox).prop('checked', false);
      }
    });
    if (!isSmartFiltersPage()) {
      $(":button.pill-button", $buttonContainer).remove()
    }
    $("span[id$='-filter-count']", $filtersContainer).empty()
    checkButtonListVisibility($buttonContainer, $checkboxes);
  });

  return {
    $buttonListContainer: $filtersContainer,
    $buttonList: $buttonContainer.find('ul'),
  };
};

const addButtonToList = ($checkbox, $buttonList, layoutType) => {
  const checkboxText = $checkbox.next().text().split('(')[0];
  const isSmartFilter = $checkbox.hasClass('js-smart-filter');
  const $filterButton = $(createFilterButton(checkboxText, isSmartFilter, layoutType));

  if(layoutType === 'page') {
    // insert new button before the "clear all" button
    $buttonList.find('.js-search-multi-filter-clear-all').before($filterButton);
  } else {
    // insert new button at the end of button list
    $buttonList.append($filterButton);
  }
  
  $filterButton.on('click', () => {
    const val = $checkbox.val();
    if (val && !isSmartFilter) {
      $(`input[value="${val}"]:not(.js-smart-filter)`).prop('checked', false);
    } else {
      $checkbox.prop('checked', false)
    }
    $checkbox.trigger('change');
    if (isSmartFilter) {
      $('#submit-smart-filters').trigger('click');
    }
  });
  return $filterButton;
};

const countChecked = ($checkboxes) => $checkboxes.filter(':checked').length;

const checkButtonListVisibility = ($buttonListContainer, $checkboxes) => {
  const $stickyElement = $('.js-left-nav-sticky-element');
  const useDisplayStyle = isSmartFiltersPage();
  if (countChecked($checkboxes)) {
    $stickyElement.addClass('sidebar-sticky--filters');
    if (useDisplayStyle) {
      $buttonListContainer.show();
    } else {
      $buttonListContainer.removeClass('u-hide');
    }
    return;
  }

  $stickyElement.removeClass('sidebar-sticky--filters');
  if (useDisplayStyle) {
    $buttonListContainer.hide();
  } else {
    $buttonListContainer.addClass('u-hide');
  }
};

const initActiveButtons = ($buttonListContainer, $buttonList, $checkboxes, {layoutType}) => {
  let filterButtonMap = {};
  $checkboxes.each((index, checkbox) => {
    const $checkbox = $(checkbox);

    if (checkbox.checked) {
      if ($checkbox.hasClass('js-smart-filter')) {
        filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
      } else {
        const inputValue = $checkbox.val();
        if (inputValue) {
          filterButtonMap[inputValue] = filterButtonMap[inputValue] || addButtonToList($checkbox, $buttonList, layoutType);
        } else {
          filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
        }
      }
    }

    if (!$checkbox.hasClass('js-smart-filter')) {
      $checkbox.on('change', function() {
        const inputValue = $(this).val();

        if (checkbox.checked) {
          if (inputValue) {
            filterButtonMap[inputValue] = filterButtonMap[inputValue] || addButtonToList($checkbox, $buttonList, layoutType);
          } else {
            filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
          }
        } else {
          if (inputValue) {
            filterButtonMap[inputValue].remove();
            delete filterButtonMap[inputValue];
          } else {
            filterButtonMap[checkbox.id].remove();
            delete filterButtonMap[checkbox.id];
          }
        }
        checkButtonListVisibility($buttonListContainer, $checkboxes);
      });
    }
  });

  $('#submit-smart-filters').on('click', function() {
    $('.js-smart-filter').each((index, checkbox) => {
      const $checkbox = $(checkbox);
      let $filterButton = filterButtonMap[checkbox.id];
      if (checkbox.checked) {
        if (!$filterButton) {
          filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
        }
      } else if ($filterButton) {
        delete filterButtonMap[checkbox.id];
        $filterButton.remove();
      }
    });
    checkButtonListVisibility($buttonListContainer, $checkboxes);
  });

  $buttonListContainer.find('.js-clear-filters-button').on('click', () => {
    Object.values(filterButtonMap).forEach($filterButton => {
      if ($filterButton) {
        $filterButton.remove();
      }
    });
    filterButtonMap = {};

    const url = new URL(window.location.href);
    window.history.pushState({}, "", removeSearchParams(url));
    $('#submit-smart-filters').data('ignoreHistory', true).trigger('click');
    checkButtonListVisibility($buttonListContainer, $checkboxes);
  });
};

/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
export default function productFilterActiveButton(container, options = {}) {
  const $container = $(container);
  const $countInitEls = $container.find('[data-filter-count]');
  const smartFilters = isSmartFiltersPage();
  const opts = mergeOptions(DEFAULTS, options, $container);
  // mount by default will be the container but can be overriden by the
  // mountEl property.
  opts.mountEl = options.mountEl ? $(options.mountEl) : $container;
  opts.layoutType = smartFilters ? 'default' : options.layoutType;
  const $checkboxes = smartFilters
    ? $('.js-smart-filter').add($container.find('input[type="checkbox"]'))
    : $container.find('input[type="checkbox"]');

  const { $buttonListContainer, $buttonList } = addButtonsContainer(opts.mountEl, $checkboxes, opts);

  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, opts);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $countInitEls.productFilterCount();
}


registerJQueryPlugin(PLUGIN_NAME, productFilterActiveButton);




// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-filter-active-button.js